/* eslint-disable @typescript-eslint/no-explicit-any */
import { handleServiceParams } from "@/helpers/serviceParamsHandler";
import {
  currentTokenUser,
  isLoggedIn,
  currentProfil,
} from "@/store/useAuthentification";
import { ApiError } from "@/types/api";
const TIMEOUT = 300000;
enum Methods {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createFetch = async <Type>(
  url: string,
  method: Methods,
  withAuth = false,
  data: any = undefined,
  params: any = {},
): Promise<any> => {
  const controller = new AbortController();
  const signal = controller.signal;
  let headers = {};
  if (
    (method === Methods.POST || method === Methods.PUT) &&
    data instanceof FormData === false
  ) {
    headers = {
      ...headers,
      "Content-Type": "application/json",
      "Content-Length": 0,
    };
  }
  if (withAuth) {
    if (!isLoggedIn.value) {
      throw new Error("Avec Authent, mais non authentifié");
    }
    headers = {
      ...headers,
      Authorization: `Bearer ${currentTokenUser.value.token}`,
    };
  }
  let body = null as FormData | string | null;
  if (data) {
    if (data instanceof FormData) {
      body = data;
    } else {
      body =
        typeof data === "string" || data instanceof String
          ? String(data)
          : JSON.stringify(data);
      headers = {
        ...headers,
        "Content-Length": String(body.length),
      };
    }
  }
  params["user_profil"] = currentProfil.value?.code;
  // if (params == null) {
  //   params = { user_profil: currentProfil.value?.code };
  // } else {
  //   params["user_profil"] = currentProfil.value?.code;
  // }

  setTimeout(() => {
    controller.abort();
  }, TIMEOUT);

  //const fullUrl = `${process.env.VUE_APP_BASE_API}${url}`;
  const fullUrl = new URL(`${process.env.VUE_APP_BASE_API}${url}`);
  if (params) fullUrl.search = handleServiceParams(params).toString();

  const response = await fetch(fullUrl.toString(), {
    headers,
    body,
    method,
    signal,
  });
  const responseBody = readResponse(response);
  if (response.ok) {
    if (response.status == 204) {
      return undefined;
    }
    return responseBody;
  }

  throw new ApiError(response, responseBody);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const readResponse = async (response: Response): Promise<any | string> => {
  const contentType = response.headers.get("Content-Type");
  const contentLength = Number.parseInt(
    response.headers.get("content-length") || "",
    10,
  );
  const hasJSONContent =
    contentType && contentType.includes("application/json");

  // Content-Disposition: attachment
  // Content-Disposition: attachment; filename="filename.jpg"
  const disposition = response.headers.get("content-disposition");
  let filename = "";
  if (disposition && disposition.indexOf("attachment") !== -1) {
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, "");
    }
  }
  const hasBlobContent =
    disposition && disposition.indexOf("attachment") !== -1 && filename != "";

  if (contentLength === 0) {
    return Promise.resolve(undefined);
  }
  if (hasJSONContent) {
    return response.json();
  }
  if (hasBlobContent) {
    return { filename: filename, blob: response.blob() };
  }
  return response.text().then((text) => {
    try {
      // même sans header de Content-type, on essaie de lire du JSON
      return JSON.parse(text);
    } catch (error) {
      // error de parsing, on renvoi le text
      return text;
    }
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const fetchWithtAuth = <Type>(url: string, params: any = {}): Promise<Type> => {
  return createFetch(url, Methods.GET, true, undefined, params);
};

const fetchWithoutAuth = <Type>(url: string): Promise<Type> => {
  return createFetch(url, Methods.GET, false, undefined, {});
};

const deleteWithAuth = <Type>(url: string): Promise<Type | undefined> => {
  return createFetch(url, Methods.DELETE, true);
};

//TODO: a supprimer en production
const deleteWithoutAuth = <Type>(url: string): Promise<Type | undefined> => {
  return createFetch(url, Methods.DELETE, false);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const postWithAuth = <Type>(url: string, data?: any): Promise<Type> => {
  return createFetch(url, Methods.POST, true, data);
};

//TODO: a supprimer en production
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const postWithoutAuth = <Type>(url: string, data?: any): Promise<Type> => {
  return createFetch(url, Methods.POST, false, data);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const putWithAuth = <Type>(url: string, data: any): Promise<Type> => {
  return createFetch(url, Methods.PUT, true, data);
};

//TODO: a supprimer en production
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const putWithoutAuth = <Type>(url: string, data: any): Promise<Type> => {
  return createFetch(url, Methods.PUT, false, data);
};

export {
  ApiError,
  fetchWithtAuth,
  fetchWithoutAuth,
  deleteWithAuth,
  deleteWithoutAuth,
  postWithAuth,
  postWithoutAuth,
  putWithAuth,
  putWithoutAuth,
};
